import { createFileRoute } from '@tanstack/react-router'
import { workspace } from '@/lib/queries/workspaces'
import { OrganizationDashboard } from '@/features/organizations'

export const Route = createFileRoute('/_authenticated/org/$orgId/')({
  loader: async ({ context, params }) => {
    // Only load page-specific data (org data loaded by parent route).
    await context.queryClient.query({
      ...workspace.findMany(params.orgId),
      staleTime: 'static',
    })
  },
  component: OrganizationDashboard,
})
